import React from 'react';
import PropTypes from 'prop-types';

import BarEntity from 'components/BarEntity';
import Container from 'components/Container';

const EntityBottomBar = ({ entity, entityType }) => (
	<Container width="entity" noPrint>
		<BarEntity breadcrumbs={null} entity={entity} entityType={entityType} />
	</Container>
);

EntityBottomBar.propTypes = {
	entity: PropTypes.object,
	entityType: PropTypes.string
};

export default EntityBottomBar;
